import { TFunction } from "i18next";
import { setDefaultFavicon, setTitle } from "../../metadata";

/**
 * Sets the default title for the waiting room
 */
export function setDefaultWaitingRoomTitle(t: TFunction) {
  setTitle(t("telehealth-core:meta.waitingRoom"));
}

/**
 * Sets the default favicon and title for the waiting room
 */
export function setDefaultWaitingRoomFaviconAndTitle(t: TFunction) {
  setDefaultFavicon();
  setDefaultWaitingRoomTitle(t);
}
